import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthorityShowDirective } from './directives/authorityshow.directive';
import { AuthorityHideDirective } from './directives/authotiryhide.directive';
import { DebounceInputDirective } from './directives/debounce-input.directive';

@NgModule({
    declarations: [
        AuthorityShowDirective,
        AuthorityHideDirective
    ],
    imports: [
        CommonModule,
        DebounceInputDirective,
        
    ],
    exports: [
        AuthorityShowDirective,
        AuthorityHideDirective,
        DebounceInputDirective
    ]
})
export class DirectivesModule { }